import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import { useCartContext } from "../context/CartContext";

const Nav = ({ aT, c_user, handleLogout }) => {
  const { total_item } = useCartContext();
  const [menuIcon, setMenuIcon] = useState();

  const handleNavItemClick = () => {
    setMenuIcon(false);
  };

  const navigate = useNavigate();

  return (
    <section id="header">
      <Link to="/">
        <img height="40px" width="100px" src="/img/logoo.png" alt="" />
      </Link>

      <div>
        <ul id="navbar" className={menuIcon ? "active" : ""}>
          <li>
            <div className="searchContainer">
              <form>
                <i className="fas fa-search"></i>
                <input
                  type="text"
                  id="searchbar-item"
                  placeholder="Search Products"
                />
              </form>
            </div>
          </li>

          <li>
            <Link to="/" onClick={handleNavItemClick}>
              Home{" "}
            </Link>
          </li>
          <li>
            <Link to="/product" onClick={handleNavItemClick}>
              {" "}
              Product{" "}
            </Link>
          </li>

          <li>
            <Link to="/contact" onClick={handleNavItemClick}>
              {" "}
              Contact{" "}
            </Link>
          </li>
          <li>
            <Link to="/blogpage" onClick={handleNavItemClick}>
              Blog
            </Link>
          </li>
          {/* 
          <li id="lg-bag">
            <Link to="/wishlist">
              <i className="fa-regular fa-heart"></i>
            </Link>
          </li> */}

          <li id="lg-bag">
            <Link to="/cart">
              <i className="fa-solid fa-bag-shopping">
                <sup>{total_item}</sup>
              </i>
            </Link>
          </li>

          <Link id="close">
            <i
              style={{ color: "#fff" }}
              onClick={() => setMenuIcon(false)}
              className="fa fa-times"
            ></i>
          </Link>

          {aT ? (
            <div className="dropdown">
              <button
                className="btn btn-secondary dropdown-toggle"
                type="button"
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Welcome {c_user && c_user}
              </button>
              <ul
                className="dropdown-menu"
                aria-labelledby="dropdownMenuButton1"
              >
                <li>
                  <Link
                    onClick={handleNavItemClick}
                    className="dropdown-item"
                    to="/profile"
                  >
                    Profile
                  </Link>
                </li>
                <li>
                  <Link
                    onClick={handleNavItemClick}
                    className="dropdown-item"
                    to="/order"
                  >
                    My Orders
                  </Link>
                </li>
                <li>
                  <Link
                    onClick={() => {
                      handleNavItemClick();
                      handleLogout();
                      navigate("/");
                      localStorage.removeItem("natureikoAccessToken");
                      localStorage.removeItem("natureikoRefreshToken");
                      window.location.reload(false);
                    }}
                    className="dropdown-item"
                  >
                    Logout
                  </Link>
                </li>
              </ul>
            </div>
          ) : (
            <li>
              <Link to="/login" onClick={handleNavItemClick}>
                Login
              </Link>
            </li>
          )}
        </ul>
      </div>

      <div id="mobile">
        <Link to="/cart">
          {" "}
          <i style={{ color: "#fff" }} className="fa-solid fa-bag-shopping">
            <sup>{total_item}</sup>
          </i>{" "}
        </Link>

        <i
          id="bar"
          style={{ color: "#fff" }}
          onClick={() => setMenuIcon(true)}
          className="fas fa-outdent"
        ></i>
      </div>
    </section>
  );
};

export default Nav;
